module.exports = __webpack_public_path__ + "assets/img/visual3.f0338aa6.png";